import { useState, useEffect } from 'react'
import { useQuery, useQueryClient } from "@tanstack/react-query"

import { adminListAuctions } from '../auctionsadminutil'
import { canCreateAuction } from '../permissionsutil'

import adminCss from '../sass/adminpage.module.scss'
import themeCss from '../../components/sass/theme.module.scss'

import CreateAuction from '../CreateAuction'
import AuctionCard from '../AuctionCard'
import NoAuctionsFound from '../NoAuctionsFound'
import { showLoading } from 'services/util'
import SolicitationReview from '../SolicitationReview'

export default function AdminPreviewAuctionPage(props) {

  const [showAuctionModal, setShowAuctionModal] = useState(false)
  const [previewAuctionList, setPreviewAuctionList] = useState([])
  const [submittedSrList, setSubmittedSrList] = useState([])
  const [removedSrList, setRemovedSrList] = useState([])
  const [approvedSrList, setApprovedSrList] = useState([])
  const [hasSrList, setHasSrList] = useState(false)

  //used to pass down codes for create auction to validate for no duplicate codes
  const [auctionCodes, setAuctionCodes] = useState([])
  const [hideCloseModalButton, setHideCloseModalButton] = useState()

  const isUserSR = localStorage.getItem('isSolicitationReviewAdmin')

  //to refresh query on changes
  const queryClient = useQueryClient()

  // load auction data by code, so it will work for deep-linking
  const { data: auctions, error, isLoading } = useQuery({
    queryKey: ["previewAuctionList"],
    queryFn: async () => await adminListAuctions('PREVIEW'),
    staleTime: 0
  })

  useEffect(() => {
    showLoading(isLoading)

    if (error) {
      console.log("Auctions not loaded: ", error)
      console.log(error.errors[0].message) // errors from Appsync take this format, there may be other formats depending on where the operation fails
    }
    else if (auctions) {
      console.log('loaded results, ', auctions)
    }
  }, [auctions, error, isLoading])

  const showCreateAuctionModal = () => {
    let newValue = !showAuctionModal
    setShowAuctionModal(newValue)
  }

  const refreshPreviewAuctionQuery = () => {
    queryClient.invalidateQueries(["previewAuctionList"])
  }

  useEffect(() => {
    if (!auctions) return

    const sortedAuctions = [...auctions].sort((a, b) => new Date(a.StartTime) - new Date(b.StartTime));
    // const previewAuctions = sortedAuctions.filter((auction) => auction.Status === 'PREVIEW')

    setPreviewAuctionList(sortedAuctions)
    setAuctionCodes(auctions.map(auction => auction.AuctionCode))
  }, [auctions])

  useEffect(() => {

    //if the user is not SR, skip SR array processing
    if (!isUserSR) return

    const approved = []
    const submitted = []
    const removed = []

    for (const auction of previewAuctionList) {
      const status = auction.ReviewStatus;
      
      //filter out auctions with no review status
      if (!status) continue

      if (status === "Approved") {
        approved.push(auction)
      } else if (status === "Submitted") {
        submitted.push(auction)
      } else if (status === "Removed") {
        removed.push(auction)
      }
    }

    setApprovedSrList(approved)
    setSubmittedSrList(submitted)
    setRemovedSrList(removed)

    const srListCheck = (submitted.length + removed.length + approved.length) === 0
    setHasSrList(srListCheck)

  }, [previewAuctionList, isUserSR])


  if (isUserSR) {

    if (hasSrList) return <NoAuctionsFound status={'preview'} />

    return (

      <div className={adminCss['auction-blocks-solicitation']}>
        <h2 className={adminCss['auction-headers']}>Auctions Awaiting Solicitation Review</h2>
          {submittedSrList.map((auction) => <SolicitationReview auctionDetail={auction} 
              history={props.history} key={auction.AuctionId} />)}
          {removedSrList.map((auction) => <SolicitationReview auctionDetail={auction} 
              history={props.history} key={auction.AuctionId} />)}
        <h2 className={adminCss['auction-headers']}>Auctions Approved by Solicitation Review</h2>
          {approvedSrList.map((auction) => <SolicitationReview auctionDetail={auction} 
              history={props.history} key={auction.AuctionId} />)}
      </div >
    )
  }

  return (
    <div>
      <div className={adminCss['auction-blocks']}>
        <h2 className={adminCss['auction-headers']}>Preview Auctions</h2>
        <p>Auctions in the Preview state are drafts. These auction sites are not accessible by attendees.</p>

        {canCreateAuction() &&
          <button className={`${themeCss['button']} ${themeCss['FilledBlue']} ${adminCss['button-create']}`} onClick={()=>showCreateAuctionModal()}>
            Create New Auction Event
          </button>}

        {previewAuctionList?.length > 0
          ? previewAuctionList.map((auction) => <AuctionCard state={'upcoming'} history={props.history} auction={auction} key={auction.AuctionId} />)
          : isLoading ?  <></> : <NoAuctionsFound status={'preview'} />
        }
      </div> 


      {showAuctionModal && 
        <>
          <div className={themeCss['modal-background']} onClick={()=>showCreateAuctionModal()}></div>
          <div className={adminCss['auction-modal']}>
            {!hideCloseModalButton && <button className={`${themeCss['button']} ${themeCss['FilledYellow']} ${themeCss['centered-button']}`} onClick={()=>showCreateAuctionModal()} >Close Modal</button>}
            <CreateAuction refreshPreviewAuctionQuery={refreshPreviewAuctionQuery} auctionCodes={auctionCodes} history={props.history}
              showCreateAuctionModal={showCreateAuctionModal} setHideCloseModalButton={setHideCloseModalButton} />
          </div>
        </>
      }
    </div>
  )
}